import { LOGIN_SUCCESS, LOGOUT, PROFILE } from "../constants/auth";

// Save authentication state to localStorage
const saveAuthState = (state) => {
  localStorage.setItem("auth", JSON.stringify(state));
};

// Load authentication state from localStorage
export const loadAuthState = () => {
  try {
    const authData = localStorage.getItem("auth");
    if (authData) {
      const parsedAuth = JSON.parse(authData);
      const now = new Date().getTime();

      if (parsedAuth.expiresAt && now > parsedAuth.expiresAt) {
        localStorage.removeItem("auth");
        return {
          token: null,
          expiresAt: null,
        };
      }
      return { isAuthenticated: true, ...parsedAuth };
    }
  } catch (error) {
    console.error("Error loading auth state:", error);
  }
  return { user: null, token: null, isAuthenticated: false, expiresAt: null };
};

// Login Action
export const login = (userName, token, expiresIn) => (dispatch) => {
  const expiresAt = new Date().getTime() + expiresIn * 1000;

  const authState = { token, expiresAt };
  saveAuthState(authState);

  dispatch({
    type: LOGIN_SUCCESS,
    payload: { isAuthenticated: true, ...authState },
  });
};

// Logout Action
export const logout = () => (dispatch) => {
  localStorage.removeItem("auth");
  dispatch({ type: LOGOUT });
};

// profile
export const updateUserProfile = (payload) => (dispatch) => {
  dispatch({
    type: PROFILE,
    payload,
  });
};
